export interface FantasyRateRow {
	Total: number;
	AthleteId: number;
	GAthleteId: string;
	BattleId: number;
	Points: number;
	Odd: number;
	FirstName: string;
	LastName: string;
	CountryId: number;
	PhotoUrl: string,
	BattleCount: number,
	SelectedUserCards: number[],
	AdPoints: DistributionPoint[],
	WinPoints: DistributionPoint[]
}

export interface FantasyInfo {
	EventId: number;
	Id: number;
	TournamentName: string;
	EventName: string;
	Points: FantasyRateRow[];
	Status: FantasyStatus,
	PlayersCount: number
}

export enum FantasyStatus {
	Calculated = 'Calculated', Open = 'Open', Closed = 'Closed'
}


export interface DistributionPoint {
	Id: string;
	Type: string;
	Key: number,
	Name: string;
	Points: number;
	Description: string;
}


export interface Card {
	id: number
	name: string
	fantasyPointId: number
	timeuse: string
	coef: number
	goldCoef: number
	silverCoef: number
	bronzeCoef: number
}

export interface UserCard {
	cardId: number
	id: number
	fantasyPointId: number
	timeuse: string
	name: string
	created: string
	status: CardStatus
	cardCoef: number,
	statusCoef: number,
	exCardData: number
}

export enum CardStatus {
	gold = 'gold',
	silver = 'silver',
	bronze = 'bronze'
}


export interface NewsSource {
	 Id: number
	 Name: string
	 RSSUrl: string
	 Type: string
}

export interface VideoSource {
	id: number
	name: string
	channelId: string
	lang: string
}

export interface News {
	Id: number
	Title: string
	Url: string
	NewsDate: string
}

export interface MobileVideo {
	id: string
	title: string
	description:string
	sourceId: number
	sourceName: string
	publishedAt:string
	thumbnailUrl: string
}


export enum PromocodeType {
	subscription = "subscription",
	coins = "coins",
	card = "card",
}

export interface Promocode {
	id: number;
	code: string;
	startAt?: string | null;
	endAt?: string;
	maxClaimCount: number;
	type: PromocodeType;
	quantity?: number | null;
	cardId?: number | null;
	exCardData: number | null
	statusCard: string | null,
	claimCount: number
}